<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Index/ImageTextSection'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="grid grid-cols-1 grid-rows-1 relative overflow-hidden h-175"
    >
      <CmsImage
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'image_1']"
        class="absolute inset-0 w-full object-cover z-10 h-175 brightness-50 xl:brightness-100 object-[70%]"
      />
      <div class="absolute inset-0 flex flex-col gap-8 items-start z-20 px-2xl py-24 pointer-events-none">
        <span class="text-H1 text-white pointer-events-auto">
          <CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']" />
        </span>
        <span class="text-H4 text-white pointer-events-auto">
          <CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']" />
        </span>
        <CmsLink
          v-slot="{ link }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_1']"
          class="pointer-events-auto"
        >
          <AppButton
            button-theme="Primary"
            :href="link?.href"
            :arrow="true"
            :target="link?.target"
          >
            <span class="link-text">{{ link?.link_text ?? "Lorem ipsum" }}</span>
          </AppButton>
        </CmsLink>
      </div>
    </div>
  </CmsCustomComponent>
</template>
